import QuizChampions from "./QuizChampions";
import TopChallenger from "./TopChallenger";

type ChartsProps = {
  quizChampions?: Array<{
    name: string;
    quizzes: number;
  }>;
  weeklyLeaders?: Array<{
    fullName: string;
    username: string;
    score: number;
  }>;
};

const Charts = ({ quizChampions, weeklyLeaders }: ChartsProps) => {
  // Use real data from API or fallback to empty arrays
  const quizChampionsLabels = quizChampions?.map(qc => qc.name) || [];
  const quizChampionsData = quizChampions?.map(qc => qc.quizzes) || [];

  // Use real weekly leaders data from API
  const topChallengerLabels = weeklyLeaders?.map(leader => leader.fullName || leader.username) || [];
  const topChallengerData = weeklyLeaders?.map(leader => leader.score) || [];

  return (
    <div className="flex flex-col lg:flex-row items-center dashboard-charts-container">
      <QuizChampions labels={quizChampionsLabels} data={quizChampionsData} />
      <TopChallenger labels={topChallengerLabels} data={topChallengerData} />
    </div>
  );
};
export default Charts;
